import React, { useState, useContext } from 'react';
import { Form, Button, Stack, Modal } from 'react-bootstrap';
import { NotifyData } from '#/services/NotificationService';
import { useForm, Controller } from 'react-hook-form';
import NotificationService from '#/services/NotificationService';
import { UserContext } from '../App';
import { SpinnerView } from './SpinnerView';

export interface NotifyModalProp {
  notify_id: string;
  notify_type: string;
  notify_kind: string;
  title: string;
  isShow?: boolean;
  isVerify: boolean;
  onSubmit: (value: { [key: string]: any }) => void;
  onClose: () => void;
}

export interface NotifyButtonProp extends Partial<NotifyData> {
  title: string;
  verifierd: boolean;
  onEnable: () => void;
  onDisable: () => void;
}

const NotifyModalView = (props: NotifyModalProp) => {
  const { control, handleSubmit, formState, reset } = useForm();
  const [verifyModal, setVerifyModal] = useState<boolean>(false);
  const ctx = useContext(UserContext);
  const service = new NotificationService(ctx.userInfo!);

  let form_type = '';
  switch (props.notify_kind) {
    case 'email':
      form_type = props.notify_kind;
      break;

    case 'sms':
      form_type = 'tel';
      break;
  }

  const onSubmit = async (values: { [key: string]: any }) => {
    service
      .updateNotify({
        id: props.notify_id,
        type: props.notify_type,
        kind: props.notify_kind,
        value: values[props.notify_kind],
      })
      .then((_) => {
        props.onClose();
        setVerifyModal(true);
        reset();
      })
      .finally(() => {
        reset();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const onVerifySubmit = async (values: { [key: string]: any }) => {
    service
      .verifyNotify({
        id: props.notify_id,
        type: props.notify_type,
        kind: props.notify_kind,
        code: values['code'],
      })
      .then((_) => {
        setVerifyModal(false);
        props.onSubmit(
          Object.fromEntries([[`${props.notify_kind}_verifier`, true]])
        );
      })
      .finally(() => {
        reset();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  const onRemove = async () => {
    service
      .removeNotify({
        id: props.notify_id,
        type: props.notify_type,
        kind: props.notify_kind,
      })
      .then((_) => {
        props.onClose();
        props.onSubmit(
          Object.fromEntries([[`${props.notify_kind}_verifier`, false]])
        );
      })
      .finally(() => {
        reset();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };

  let modal = <></>;
  if (props.isVerify) {
    modal = (
      <Modal show={props.isShow || false} centered onHide={props.onClose}>
        <Modal.Header closeButton>通知設定</Modal.Header>
        <Modal.Body>
          <p className="mb-3">通知設定を削除してもよろしいですか？</p>
          <Form onSubmit={handleSubmit(onRemove)}>
            <Form.Group className="mb-3 text-center">
              <Controller
                control={control}
                name="submit"
                render={({ field: { ref } }) => (
                  <Button
                    variant="danger"
                    type="submit"
                    className="w-50"
                    disabled={formState.isSubmitted}
                    ref={ref}
                  >
                    {formState.isSubmitted ? (
                      <SpinnerView size="sm" />
                    ) : (
                      '削除する'
                    )}
                  </Button>
                )}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    );
  } else {
    modal = (
      <Modal show={props.isShow || false} centered onHide={props.onClose}>
        <Modal.Header closeButton>通知設定</Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3">
              <Form.Label>{props.title}</Form.Label>
              <Controller
                control={control}
                name={props.notify_kind}
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Control
                    type={form_type}
                    onChange={onChange}
                    value={value || ''}
                    ref={ref}
                  />
                )}
              />
            </Form.Group>
            <Form.Group className="text-center">
              <Controller
                control={control}
                name="submit"
                render={({ field: { ref } }) => (
                  <Button
                    type="submit"
                    className="w-50"
                    disabled={formState.isSubmitted}
                    ref={ref}
                  >
                    {formState.isSubmitted ? (
                      <SpinnerView size="sm" />
                    ) : (
                      '認証コードを送信'
                    )}
                  </Button>
                )}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    );
  }

  return (
    <>
      {modal}
      <Modal
        show={verifyModal}
        centered
        onHide={() => {
          setVerifyModal(false);
        }}
      >
        <Modal.Header closeButton>通知設定</Modal.Header>
        <Modal.Body>
          <Form
            key={`${props.notify_kind}_verify`}
            onSubmit={handleSubmit(onVerifySubmit)}
          >
            <Form.Group className="mb-3">
              <Form.Label>認証コード（６桁）</Form.Label>
              <Controller
                control={control}
                name="code"
                render={({ field: { onChange, value, ref } }) => (
                  <Form.Control
                    type="numeric"
                    onChange={onChange}
                    value={value || ''}
                    ref={ref}
                  />
                )}
              />
            </Form.Group>
            <Form.Group className="text-center">
              <Controller
                control={control}
                name="submit"
                render={({ field: { ref } }) => (
                  <Button
                    type="submit"
                    className="w-50"
                    disabled={formState.isSubmitted}
                  >
                    {formState.isSubmitted ? (
                      <SpinnerView size="sm" />
                    ) : (
                      '認証する'
                    )}
                  </Button>
                )}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

const NotifyButtonView = (props: NotifyButtonProp) => {
  let status = '';
  let btn = <></>;
  if (props.verifierd) {
    status = '設定済み';
    btn = (
      <Button variant="danger" onClick={props.onDisable}>
        削除する
      </Button>
    );
  } else {
    status = '未設定';
    btn = (
      <Button variant="primary" onClick={props.onEnable}>
        設定する
      </Button>
    );
  }

  return (
    <Stack direction="horizontal" className="mb-3">
      <span>{props.title}</span>
      <span>：</span>
      <span>{status}</span>
      <span className="ms-4">{btn}</span>
    </Stack>
  );
};

export { NotifyModalView, NotifyButtonView };
